import { IsInstanceOf } from "@utils/class-validator/class-validator-constraints";
import { Type } from "class-transformer";
import { IsOptional, IsString } from "class-validator";

export class CrmContact {
  @IsOptional()
  @IsString()
  department?: string;

  @IsOptional()
  @IsString()
  salutation?: string;

  @IsOptional()
  @IsString()
  firstname?: string;

  @IsOptional()
  @IsString()
  lastname?: string;

  @IsOptional()
  @IsString()
  jobtitle?: string;

  @IsOptional()
  @IsString()
  telephone?: string;

  @IsOptional()
  @IsString()
  mobilePhone?: string;

  @IsOptional()
  @IsString()
  email?: string;
}

export class CrmCompany {
  @IsOptional()
  @IsString()
  accountNumber?: string;

  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  additionalName2?: string;

  @IsOptional()
  @IsString()
  additionalName3?: string;

  @IsOptional()
  @IsString()
  additionalName4?: string;

  @IsOptional()
  @IsString()
  streetAndHouseNumber?: string;

  @IsOptional()
  @IsString()
  city?: string;

  @IsOptional()
  @IsString()
  postalCode?: string;
}

export class CrmCustomer {
  @IsOptional()
  @IsString()
  accountNumber?: string;

  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  streetAndHouseNumber?: string;

  @IsOptional()
  @IsString()
  city?: string;

  @IsOptional()
  @IsString()
  postalCode?: string;
}

export class CrmEntry {
  @IsOptional()
  @IsString()
  id?: string;

  @IsOptional()
  @IsString()
  sourceType?: "contact" | "opportunity";

  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  opportunityId?: string;

  @IsOptional()
  @IsString()
  opportunityLink?: string;

  @IsOptional()
  @Type(() => CrmContact)
  @IsInstanceOf(CrmContact)
  contact?: CrmContact;

  @IsOptional()
  @Type(() => CrmCompany)
  @IsInstanceOf(CrmCompany)
  company?: CrmCompany;

  @IsOptional()
  @Type(() => CrmCustomer)
  @IsInstanceOf(CrmCustomer)
  customerShippedTo?: CrmCustomer;

  @IsOptional()
  @Type(() => CrmCustomer)
  @IsInstanceOf(CrmCustomer)
  customerSoldTo?: CrmCustomer;

  @IsOptional()
  @Type(() => CrmCustomer)
  @IsInstanceOf(CrmCustomer)
  endUser?: CrmCustomer;
}
